'use client';

import Link from '@eliadmin/core/src/components/link';

import type {
  GeneralLayout,
  Menu,
} from '@eliadmin/core/src/api/general/types/general-layout-types';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@eliadmin/core/src/components/ui/accordion';

import { getSafeHref } from '@eliadmin/core/src/utils/url-utils';
import { GoDotFill } from 'react-icons/go';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function AccordionMenu({
  menu,
  generalLayout,
}: {
  menu: Menu[];
  generalLayout: GeneralLayout;
}) {
  return (
    <Accordion
      type="single"
      collapsible
      className="flex w-full flex-col items-start justify-start gap-0 sm:hidden"
    >
      {menu.map(item => (
        <AccordionItem
          key={item.name}
          value={item.name}
          className="w-full border-b border-t-0 border-b-white/20 p-0 py-4"
        >
          <AccordionTrigger
            className={cn(
              'py-0 text-lg font-medium text-white !no-underline',
              'ea-accordion-menu__trigger',
            )}
          >
            {item.name}
          </AccordionTrigger>
          <AccordionContent className="flex flex-col items-start justify-start gap-2 p-0 pt-6">
            {item.fields.map(field => (
              <Link
                prefetch={false}
                href={getSafeHref(field?.path ?? '')}
                key={field.name}
                className="flex items-center justify-start gap-2 text-sm font-normal text-white"
              >
                <GoDotFill size={8} className="text-primary" />
                {field.name}
              </Link>
            ))}
          </AccordionContent>
        </AccordionItem>
      ))}
      <AccordionItem value="kontakt" className="w-full border-none p-0 py-4">
        <AccordionTrigger
          className={cn(
            'py-0 text-lg font-medium text-white !no-underline',
            'ea-accordion-menu__trigger',
          )}
        >
          Kontakt
        </AccordionTrigger>
        <AccordionContent className="flex flex-col items-start justify-start gap-2 p-0 pt-6">
          <div className="flex w-full flex-col items-start justify-start gap-2">
            <Link
              prefetch={false}
              href={`tel:${generalLayout.data.contact?.phone}`}
              className="text-sm font-normal text-white"
            >
              {generalLayout.data.contact?.phone}
            </Link>
            <Link
              prefetch={false}
              href={`mailto:${generalLayout.data.contact?.email}`}
              className="text-sm font-normal text-white"
            >
              {generalLayout.data.contact?.email}
            </Link>
          </div>
          <h4 className="text-lg font-medium text-white lg:text-xl">Prevádzková doba</h4>
          <div className="flex w-full flex-col items-start justify-start gap-2">
            <p className="text-sm font-normal text-white">Po - Pia: 8:00 - 16:00</p>
            <p className="text-sm font-normal text-white">So - Ne: zatvorené</p>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
